// extracted by mini-css-extract-plugin
module.exports = {"bodySection":"styles-module--bodySection--3Ihea","faq":"styles-module--faq--3EpjH","item":"styles-module--item--1sOzp"};